// extracted by mini-css-extract-plugin
export default {"training-event-type-select":"TrainingEventTypeSelect_training-event-type-select__X0Z7C"};